/** Tạm ứng bệnh nhân. Real /api/v1/patients/{id}/deposit. */
import { apiClient } from "./client";
import { randomUuid } from "../randomUuid";

export interface DepositTxn {
  kind: "DEPOSIT" | "APPLY" | "REFUND" | "ADJUST";
  amount: number; // signed VND: + adds, - reduces
  invoiceId: string | null;
  reason: string | null;
  at: string;
}

export const depositApi = {
  balance(patientId: string): Promise<number> {
    return apiClient
      .get<{ balance: number }>(`/v1/patients/${patientId}/deposit`)
      .then((r) => r.data.balance);
  },
  history(patientId: string): Promise<DepositTxn[]> {
    return apiClient
      .get<DepositTxn[]>(`/v1/patients/${patientId}/deposit/txns`)
      .then((r) => r.data);
  },
  deposit(patientId: string, amount: number, reason: string | null): Promise<number> {
    return apiClient
      .post<{ balance: number }>(`/v1/patients/${patientId}/deposit`, { amount, reason }, idem())
      .then((r) => r.data.balance);
  },
  apply(patientId: string, invoiceId: string, amount: number): Promise<number> {
    return apiClient
      .post<{ balance: number }>(
        `/v1/patients/${patientId}/deposit/apply`,
        { invoiceId, amount },
        idem(),
      )
      .then((r) => r.data.balance);
  },
  refund(patientId: string, amount: number, reason: string | null): Promise<number> {
    return apiClient
      .post<{ balance: number }>(`/v1/patients/${patientId}/deposit/refund`, { amount, reason }, idem())
      .then((r) => r.data.balance);
  },
};

/** A fresh Idempotency-Key per money mutation so a network-level resend can't double-post. */
function idem() {
  return { headers: { "Idempotency-Key": randomUuid() } };
}

export const depositQueryKeys = {
  balance: (patientId: string) => ["deposit-balance", patientId] as const,
  txns: (patientId: string) => ["deposit-txns", patientId] as const,
};
